// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_n1-0";
export var animationContainer = "_n1-1";
export var itemPrice = "_n1-a";
export var itemizedContent = "_n1-9";
export var itemizedHeader = "_n1-7";
export var itemizedRow = "_n1-8";
export var itemizedSection = "_n1-6";
export var modalContent = "_n1-2";
export var orderName = "_n1-3";
export var refundOption = "_n1-4";
export var refundOptionsContainer = "_n1-5";
export var shippingLabel = "_n1-b";
export var totalRow = "_n1-c";